// @ts-nocheck
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
// hooks
import useAuth from '../hooks/useAuth';
// pages
import Login from '../pages/authentication/Login';
// services
import { setPendingPath } from '../services/pendingIntent';
// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node
};

// Onboarding is now soft-gated via the user-checklist task
// ("Complete your onboarding") rather than a hard redirect on role=10.
// The wizard remains reachable at /onboarding; users can opt in any time.
export default function AuthGuard({ children }) {
  const { isAuthenticated } = useAuth();
  const { pathname, search } = useLocation();
  const fullPath = pathname + search;
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isAuthenticated) {
    if (fullPath !== requestedLocation) {
      setRequestedLocation(fullPath);
    }
    // A QR-scan deep-link (/m/...) hit while logged out: stash the full path so
    // the auth flow can replay it instead of dumping the worker on /dashboard,
    // then route them to the SITE-AWARE sign-in page (which links to register)
    // rather than the generic login — so they see they're joining a specific
    // site. The jobsite handle is the 3rd segment of /m/<action>/<handle>; a
    // bare /m (the site picker) has none, so it falls back to the generic login.
    if (pathname.startsWith('/m/')) {
      setPendingPath(fullPath);
      const handle = pathname.split('/')[3];
      if (handle) {
        return <Navigate to={`/m/login/${handle}`} replace />;
      }
    }
    return <Login />;
  }

  if (requestedLocation && fullPath !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
